import React from 'react';
import { Alert } from '../Alert/Alert';
import { localise } from '../../../services/lang/lang';
import { PAGE_CONTENT_PADDING_X } from '../PageContent/PageContent';
export const PermissionGuardAlertBox = (props) => {
    const px = props.isFullPage ? PAGE_CONTENT_PADDING_X : undefined;
    return (React.createElement(Alert, { "data-testid": "permission_guard_banner", status: "info", icon: true, px: px, title: localise('PERMISSION_GUARD_BANNER_HEADING') }, localise('PERMISSION_GUARD_BANNER_DESCRIPTION')));
};
